import { WifiOff } from 'lucide-react';
import { useSyncExternalStore } from 'react';

import { ptBR } from '@/i18n/pt-BR';
import { cn } from '@/lib/utils';

function subscribeOnline(notify: () => void): () => void {
  window.addEventListener('online', notify);
  window.addEventListener('offline', notify);
  return () => {
    window.removeEventListener('online', notify);
    window.removeEventListener('offline', notify);
  };
}

function getSnapshotOnline(): boolean {
  return typeof navigator === 'undefined' ? true : navigator.onLine;
}

function getServerSnapshotOnline(): boolean {
  // No SSR/teste sem window, assume conectado.
  return true;
}

export interface OfflineBannerProps {
  className?: string;
}

/**
 * Banner discreto exibido no topo do Shell quando `navigator.onLine` é false.
 * Reativo via eventos `online`/`offline` em `window` (sem polling).
 * Não ocupa espaço quando online — render zero.
 */
export function OfflineBanner({ className }: OfflineBannerProps) {
  const online = useSyncExternalStore(subscribeOnline, getSnapshotOnline, getServerSnapshotOnline);
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
      className={cn(
        'flex items-center justify-center gap-2 bg-warning-50 px-4 py-2 text-body-sm text-warning-700',
        className,
      )}
    >
      <WifiOff className="h-4 w-4" aria-hidden />
      <span>{ptBR.errors.networkOffline}</span>
    </div>
  );
}
